import { Group } from '@/types/groups.types';
import { Store } from '@/types/stores.types';

/**
 *  Convert your list of Store objects into a Map that holds the groupName as the key and the count of occurrences as the value:
 * @param stores
 * @returns
 */
export const buildMapGroupNameCountForStores = (stores: Store[]): Map<string, number> =>
  stores.reduce((map, store) => {
    map.set(store.groupName, (map.get(store.groupName) || 0) + 1);
    return map;
  }, new Map<string, number>());

/**
 * Convert your list of Group objects into a Map that holds the name (groupName) as the key and storesCount as the value:
 * @param groups
 * @returns
 */
export const buildMapGroupNameCountForGroups = (groups: Group[]): Map<string, number> =>
  new Map(groups.map((group) => [group.name, group.storesCount]));

/**
 * returns entries from the first map where the store count exactly matches the corresponding store count in the second map:
 * @param firstMap
 * @param secondMap
 * @returns
 */
export const filterMatchingStoreCounts = (firstMap: Map<string, number>, secondMap: Map<string, number>): string[] => {
  const matchingEntries = new Map<string, number>();

  firstMap.forEach((count, key) => {
    if (secondMap.has(key) && secondMap.get(key) === count) {
      matchingEntries.set(key, count);
    }
  });

  return [...matchingEntries.keys()];
};
